export default __webpack_public_path__ + "static/media/AvertaDemoPECuttedDemo-Regular.397a1b06.otf";